import { Provider } from "react-redux";
import { RouterProvider } from "react-router-dom";
import { store } from "@/store";
import { ThemeProvider } from "@/context/ThemeContext";
import { NotificationProvider } from "@/context/NotificationContext";
import { AuthInit } from "@/components/AuthInit";
import { router } from "@/router";

export function App() {
  return (
    <Provider store={store}>
      <ThemeProvider>
        <NotificationProvider>
          <AuthInit>
            <RouterProvider router={router} />
          </AuthInit>
        </NotificationProvider>
      </ThemeProvider>
    </Provider>
  );
}
